/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Nav_Group_TertiaryInputs */

const en_layout_nav_group_tertiary = /** @type {(inputs: Layout_Nav_Group_TertiaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

const pl_layout_nav_group_tertiary = /** @type {(inputs: Layout_Nav_Group_TertiaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przestrzeń robocza`)
};

/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Layout_Nav_Group_TertiaryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_nav_group_tertiary = /** @type {((inputs?: Layout_Nav_Group_TertiaryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Nav_Group_TertiaryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_nav_group_tertiary(inputs)
	return en_layout_nav_group_tertiary(inputs)
});